<template>
    <div class="card shadow-sm">
        <div class="card-body">
            <div class="account-detail">
                <h6 class="card-subtitle mb-2 text-muted">Account Number</h6>
                <h5 class="card-title">{{ account.account_number }}</h5>
            </div>
            <div class="account-detail">
                <h6 class="card-subtitle mb-2 text-muted">Account Type</h6>
                <h5 class="card-title">{{  account.type }}</h5>
            </div>
            <div class="account-detail">
                <h6 class="card-subtitle mb-2 text-muted">Bank Name</h6>
                <h5 class="card-title">{{ account.bank_details.name }}</h5>
            </div>
            <div class="account-detail" v-tooltip:bottom="`Routing number: ${account.branch_details.routing_number}`">
                <h6 class="card-subtitle mb-2 text-muted">Branch</h6>
                <h5 class="card-title">{{  account.branch_details.name }}</h5>
            </div>
        </div>
    </div>
</template>

<style scoped>
	.card {
		height: 290px;
	}

	.card-body {
		padding: 25px;
	}

	.account-detail {
		margin-bottom: 25px;
	}
</style>

<script>
	export default {
		props: ["account"]
	};
</script>